import { Staff } from '@/models/user';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'umi';

export default function useStaff() {
  const [loading, setLoading] = useState<boolean>(false);
  const data: Staff[] = useSelector((state: any) => state.user.staff);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await dispatch({ type: 'user/getStaff' });
      setLoading(false);
    }
    if (data.length === 0) {
      fetchData();
    }
  }, []);

  return { data, loading }
}